var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newsitem!=='undefined')?_c('NewsForm',{attrs:{"adminmethod":"update","newsitem":_vm.newsitem}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }